module.exports = __webpack_public_path__ + "img/R. Yaacov Amar.cd60fc90.png";